var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "AutoHandoverInbound"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-hover datatables tbl",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "20px"
    }
  }, [_vm._v("Facility/Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "20px"
    }
  }, [_vm._v("Action ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "20px"
    }
  }, [_vm._v("User ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "20px"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.auditData), function(data, index) {
    return _c('tr', [(data.bagtypes == 'All') ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(data.hubname))]) : _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(data.bagtypes))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(data.action))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20px"
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), _vm._v(" "), (_vm.auditData.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd60354","hasScoped":true}!./src/views/components/AutoBagOutConfiguration_v1/Audit/Audit.html
// module id = 1982
// module chunks = 2